import { provideHttpClient, withXhr } from '@angular/common/http';
import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { merge } from '@shopware-operations/ts-utils';
import { OryIamConfig } from './model';
import { OryService } from './ory.service';

const defaultConfig: OryIamConfig = {
  base: {
    iamApiEndpoint: 'http://localhost:5432',
    baseOptions: {
      withCredentials: true
    },
    registration: {
      verificationRequired: true,
      sessionCreatedOnRegistration: true,
    },
  },
  oidc: {
    oauthApiEndpoint: 'http://localhost:4321',
    pathAuthorize: '/oauth/authorize',
    pathConsent: '/oauth/consent',
  },
}

/**
 * Provides Ory IAM services with configuration.
 *
 * Merges provided config with defaults and registers all Ory services.
 * Call this in your app.config.ts providers array.
 *
 * @example
 * ```typescript
 * export const appConfig: ApplicationConfig = {
 *   providers: [
 *     provideOryIam({
 *       base: {
 *         iamApiEndpoint: 'https://your-kratos.ory.com',
 *       },
 *       oidc: {
 *         oauthApiEndpoint: 'https://your-oauth-api.com',
 *       }
 *     })
 *   ]
 * };
 * ```
 */
export const provideOryIam = (config: Partial<OryIamConfig>): EnvironmentProviders => {
  const mergedConfig = merge(defaultConfig, config);
  return makeEnvironmentProviders([
    provideHttpClient(withXhr()),
    { provide: OryIamConfig, useValue: mergedConfig },
    OryService,
  ])
}
